import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { PackingGameCoreService } from './packing-game-core.service';
import { PackingGameSelectorComponent } from './packing-game-selector/packing-game-selector.component';

@NgModule({
  declarations: [PackingGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [PackingGameCoreService],
  exports: [PackingGameSelectorComponent],
})
export class PackingGameCoreModule {}
